const INDEX_CONTAINER_CLASSNAME = '.assignment-templates'
import Sortable from "sortablejs"

$(document).on('turbolinks:load', function() {
  $(INDEX_CONTAINER_CLASSNAME + " .bulk-task").attr("disabled", true);

  const table_row_checkbox = INDEX_CONTAINER_CLASSNAME + ' .row-checkbox';

  var el = $('#selected_task_list');

  if(el.length != 0) {
    var sortable = new Sortable(el[0], {
      onUpdate: function (/**Event*/evt) {
        $.ajax({
          url: "update_task_list",
          method: "POST",
          data: { task_ids: sortable.toArray(), type: "sort" },
          success: (response) => {
          },
          error: function(response) {
            console.log('Something went wrong. Please try again.');
          }
        });
      },
    
    });
  }

  $('body').on('click', table_row_checkbox, function() {
    if ($(table_row_checkbox + ":checked").length > 0){
      $(".bulk-task").attr("disabled", false);
    } else {
      $(".bulk-task").attr("disabled", true);
    }
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .bulk-delete').click(function() {
    var template_ids = []
    $(table_row_checkbox + ':checked').each(function(i, obj){
      template_ids.push(obj.id)
    })

    if (confirm('Delete all selected tasks?')){
      $.ajax({
        url: "/assignment_templates/bulk_delete",
        method: "DELETE",
        data: { template_ids: template_ids },
        success: (response) => {
          location.reload();
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
    else {
      return false;
    }
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .bulk-clone').click(function() {
    var template_ids = []
    $(table_row_checkbox + ':checked').each(function(i, obj){
      template_ids.push(obj.id)
    })

    if (confirm('Clone all selected tasks?')){
      $.ajax({
        url: "/assignment_templates/bulk_clone",
        method: "POST",
        data: { template_ids: template_ids},
        success: (response) => {
          setTimeout(function(){ location.reload() }, 1000);
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
    else {
      return false;
    }

  });

  $('#task-select').select2({
    ajax: {
      url: '/training_tasks_search.json',
      dataType: 'json',
    },
    templateResult: function (res) {
      var $container = null
      $container = $("<div id=task-"+res.id+">" + res.text + "</div>");

      return $container;
    }
  });

  $('body').on('click', '.remove-selected-task', function() {
    var id = this.id

    $.ajax({
      url: "update_task_list",
      method: "POST",
      data: { task_id: id, type: "delete" },
      success: (response) => {
        $('#selected_task_list #task-' + id).remove();
      },
      error: function(response) {
        console.log('Something went wrong. Please try again.');
      }
    });
  });

  $("#task-select").change(function(){
    var obj = $(this).select2('data')[0];

    var list_div = "<li class='list-group-item d-flex justify-content-between align-items-center' data-id='"+obj.id+"' id='task-"+obj.id+"'>"+obj.text+"<button class='btn remove-selected-task' id='"+obj.id+"'><i class='fa fa-trash' aria-hidden='true'></i></button></li>"
    
    $.ajax({
      url: "update_task_list",
      method: "POST",
      data: { task_id: obj.id, type: "add" },
      success: (response) => {
        $("#selected_task_list").append(list_div)
      },
      error: function(response) {
        alert("Task already added to the list")
      }
    });

  });

});